import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col-md-4 mb-3" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col" }

import AppPageHeader from "@/components/app/AppPageHeader.vue";
import SilpoChequeList from "@/components/shopping/silpo/SilpoChequeList.vue";
import SilpoLoadLastChequesForm from "@/components/shopping/silpo/SilpoLoadLastChequesForm.vue";
export default /*#__PURE__*/_defineComponent({
  __name: 'ChequesListView',
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(AppPageHeader, null, {
      default: _withCtx(() => [
        _createTextVNode("Silpo cheques")
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(SilpoLoadLastChequesForm)
      ])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createVNode(SilpoChequeList)
      ])
    ])
  ], 64))
}
}

})